import homePage from './pages/homePage';



const routes = [
  {
    path: '/brand-blitz-quiz',
    component: homePage,
    exact: true
  }
  
 // and so on for other routes in your project
]

export default routes;